import React from "react";
import type { ButtonGroupProps, Theme } from "@material-ui/core";
import { alpha, ButtonGroup, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        "& .MuiButtonGroup-groupedOutlinedHorizontal": {
            "&.MuiButton-outlined": {},

            "&:not(:first-child)": {
                marginLeft: -2,
            },

            "&.MuiButton-outlinedPrimary": {
                borderRightColor: alpha(theme.palette.primary.main, 0.5),
                borderWidth: 2,
                "&:hover": {
                    borderRightColor: theme.palette.primary.main,
                },

                "& + .MuiButton-outlined": {
                    borderLeftColor: "transparent",
                },
            },
        },
    },
}));

type ToggleButtonGroupProps = ButtonGroupProps;

/** Adds active class styling and adjust margins/borders */
export const ToggleButtonGroup = (props: ToggleButtonGroupProps) => {
    const classes = useStyles();

    return (
        <ButtonGroup variant="outlined" classes={{ root: classes.root }} {...props}>
            {props.children}
        </ButtonGroup>
    );
};
